import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AiButtons = _resolveComponent("AiButtons")
  const _component_AiMultiselect = _resolveComponent("AiMultiselect")
  const _component_AiSelect = _resolveComponent("AiSelect")
  const _component_AiText = _resolveComponent("AiText")
  const _component_AiProfileSelect = _resolveComponent("AiProfileSelect")
  const _component_AiVerticalSelect = _resolveComponent("AiVerticalSelect")

  return ($options.type === 'buttons')
    ? (_openBlock(), _createBlock(_component_AiButtons, {
        key: 0,
        options: $options.items,
        answer: $props.answer,
        disabled: $props.disabled,
        onPrompt: _cache[0] || (_cache[0] = $event => (_ctx.$emit('prompt', $event)))
      }, null, 8 /* PROPS */, ["options", "answer", "disabled"]))
    : ($options.type === 'multiselect')
      ? (_openBlock(), _createBlock(_component_AiMultiselect, {
          key: 1,
          options: $options.items,
          skip: $options.skip,
          disabled: $props.disabled,
          onPrompt: _cache[1] || (_cache[1] = $event => (_ctx.$emit('prompt', $event)))
        }, null, 8 /* PROPS */, ["options", "skip", "disabled"]))
      : ($options.type === 'select')
        ? (_openBlock(), _createBlock(_component_AiSelect, {
            key: 2,
            options: $options.items,
            skip: $options.skip,
            disabled: $props.disabled,
            onPrompt: _cache[2] || (_cache[2] = $event => (_ctx.$emit('prompt', $event)))
          }, null, 8 /* PROPS */, ["options", "skip", "disabled"]))
        : ($options.type === 'text')
          ? (_openBlock(), _createBlock(_component_AiText, {
              key: 3,
              disabled: $props.disabled,
              answer: $props.answer,
              query: $options.chat_query,
              skip: $options.skip,
              "skip-all": $options.skip_all,
              onPrompt: _cache[3] || (_cache[3] = $event => (_ctx.$emit('prompt', $event)))
            }, null, 8 /* PROPS */, ["disabled", "answer", "query", "skip", "skip-all"]))
          : ($options.type === 'profile_select')
            ? (_openBlock(), _createBlock(_component_AiProfileSelect, {
                key: 4,
                options: $options.items,
                answer: $props.answer,
                disabled: $props.disabled,
                skip: $options.skip,
                "skip-all": $options.skip_all,
                onPrompt: _cache[4] || (_cache[4] = $event => (_ctx.$emit('prompt', $event)))
              }, null, 8 /* PROPS */, ["options", "answer", "disabled", "skip", "skip-all"]))
            : ($options.type === 'vertical_select')
              ? (_openBlock(), _createBlock(_component_AiVerticalSelect, {
                  key: 5,
                  options: $options.items,
                  answer: $props.answer,
                  disabled: $props.disabled,
                  skip: $options.skip,
                  "skip-all": $options.skip_all,
                  onPrompt: _cache[5] || (_cache[5] = $event => (_ctx.$emit('prompt', $event)))
                }, null, 8 /* PROPS */, ["options", "answer", "disabled", "skip", "skip-all"]))
              : _createCommentVNode("v-if", true)
}